import React from 'react';
import PropTypes from 'prop-types';
import GiftMessageForm from '../GiftMessageForm/GiftMessageForm';
import OverlayModal from '../ContentSystem/components/OverlayModal/OverlayModal';

/**
 * `GiftMessageDialog` is a container used to handle the logic for showing the GiftMessage form.
 */
const GiftMessageDialog = ({ note, isOpen, onCloseClick }) => (
  <OverlayModal
    isOpen={isOpen}
    onRequestClose={onCloseClick}
    onClickBackButton={onCloseClick}
    showHeaderBackButton
    header="Gift Message"
    withPadding={false}
  >
    <GiftMessageForm
      onComplete={onCloseClick}
      onReject={onCloseClick}
      note={note}
    />
  </OverlayModal>
);

GiftMessageDialog.propTypes = {
  /**
   * `true` to display the gift message dialog
   */
  isOpen: PropTypes.bool,
  /**
   * callback function to close the modal
   */
  onCloseClick: PropTypes.func.isRequired,
  /**
   * Prefilled value for gift message text area
   */
  note: PropTypes.string
};

GiftMessageDialog.defaultProps = {
  isOpen: false,
  note: ''
};

export default GiftMessageDialog;
